import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import dayjs from "dayjs";

import { AI_AGENT_MEETING, AI_AGENT_MEETING_ROOT } from "app/pages/sales-intelligence/constants/routes";
import { useGetThreads } from "app/pages/sales-intelligence/modules/ai-agent/queries/useGetThreads";
import { MEETING_AGENT_SOURCE } from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/constants";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const THREAD_FRESHNESS_WEEKS = 3;

const isThreadFresh = (createdDate: string): boolean => {
    return dayjs(createdDate).isAfter(dayjs().subtract(THREAD_FRESHNESS_WEEKS, "week"));
};

export const AIAgentMeetingLatestPageContent = () => {
    const {
        params: { domain, attendee },
    } = useCurrentStateAndParams<{ domain: string; attendee: string }>();

    const { data: historyThreads, isLoading } = useGetThreads();

    useEffect(() => {
        if (isLoading) {
            return;
        }
        if (domain) {
            const latestThread = historyThreads?.find(
                (thread) =>
                    thread.domain === domain &&
                    thread.calendarAttendees === attendee &&
                    isThreadFresh(thread.createdDate),
            );
            if (latestThread) {
                void proNavigator.go(
                    AI_AGENT_MEETING,
                    { domain, id: latestThread.threadId, source: MEETING_AGENT_SOURCE.gCalendar },
                    { reload: true },
                );
            } else {
                void proNavigator.go(
                    AI_AGENT_MEETING,
                    {
                        domain,
                        id: undefined,
                        autogenerate: true,
                        attendee,
                        source: MEETING_AGENT_SOURCE.gCalendar,
                    },
                    { reload: true },
                );
            }
        } else {
            void proNavigator.go(AI_AGENT_MEETING_ROOT);
        }
    }, [domain, historyThreads, attendee, isLoading]);

    return null;
};
